
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[guild]",
      function () {
        return require("private-next-pages/[guild]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[guild]"])
      });
    }
  